module.exports = __webpack_public_path__ + "static/media/icn_metamask.e8109252.svg";